import { buildModelManager } from "../builder.js";
const DefaultFormQrCodeSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  earlyGenerationNote: true,
  expiresAt: true,
  generatedAt: true,
  generatedByIp: true,
  generatedByLatitude: true,
  generatedByLongitude: true,
  institution: true,
  institutionFormId: true,
  isActive: true,
  qrType: true,
  shiftDocumentationId: true,
  shiftId: true,
  studentId: true,
  token: true,
  updatedAt: true,
  usedAt: true,
  usedByIp: true,
  usedByLatitude: true,
  usedByLongitude: true
};
const modelApiIdentifier = "formQrCode";
const pluralModelApiIdentifier = "formQrCodes";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultFormQrCodeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultFormQrCodeSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFormQrCodeSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFormQrCodeSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFormQrCodeSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultFormQrCodeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultFormQrCodeSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByToken",
    findByField: "token",
    findByVariableName: "token",
    modelApiIdentifier,
    defaultSelection: DefaultFormQrCodeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByToken",
    findByField: "token",
    findByVariableName: "token",
    modelApiIdentifier,
    defaultSelection: DefaultFormQrCodeSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createFormQrCode",
    operationReturnType: "CreateFormQrCode",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { formQrCode: { required: false, type: "CreateFormQrCodeInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFormQrCodeSelection
  },
  {
    type: "action",
    operationName: "bulkCreateFormQrCodes",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateFormQrCodesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultFormQrCodeSelection
  },
  {
    type: "action",
    operationName: "updateFormQrCode",
    operationReturnType: "UpdateFormQrCode",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      formQrCode: { required: false, type: "UpdateFormQrCodeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFormQrCodeSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateFormQrCodes",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateFormQrCodesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultFormQrCodeSelection
  },
  {
    type: "action",
    operationName: "deleteFormQrCode",
    operationReturnType: "DeleteFormQrCode",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteFormQrCodes",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertFormQrCode",
    operationReturnType: "UpsertFormQrCode",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      formQrCode: { required: false, type: "UpsertFormQrCodeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateFormQrCodeResult": { hasReturnType: false },
      "... on UpdateFormQrCodeResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFormQrCodeSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertFormQrCodes",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertFormQrCodesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultFormQrCodeSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "formQrCodeGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const FormQrCodeManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultFormQrCodeSelection,
  operations
);
export {
  DefaultFormQrCodeSelection,
  FormQrCodeManager
};
//# sourceMappingURL=FormQrCode.js.map
